import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { IntegratedIReckonRoomEffects } from './integrated-ireckon-room.effects';
import { integratedIReckonRoomReducer } from './integrated-ireckon-room.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('integratedIReckonRoom', integratedIReckonRoomReducer),
    EffectsModule.forFeature([IntegratedIReckonRoomEffects]),
  ],
  providers: [],
})
export class IntegratedIReckonRoomStoreModule {}
